<template>
  <menikheim-layout>
    <template #content>
      <div class="container">
        <h1>Datenschutz</h1>
        <p>Stand: November 2026</p>
        <h2>1. Verantwortlicher</h2>
        <p>Menikheim Stuckateur GmbH<br />Brühlstr. 20<br />73635 Rudersberg<br />
          Telefon: 07183 / 8428<br />
          E-Mail: <a href="mailto:info@menikheim-stuck.de">info@menikheim-stuck.de</a>
        </p>
        <p>Vertreten durch den Geschäftsführer Steffen Menikheim.</p>
        <h2>2. Das Wichtigste in Kürze</h2>
        <ul>
          <li>Diese Webseite setzt keine Cookies.</li>
          <li>Wir nutzen keine Analyse- oder Tracking-Werkzeuge und keine Werbedienste.</li>
          <li>Schriften und Bilder liegen auf unserem eigenen Webspace. Inhalte von Drittanbietern werden nicht nachgeladen.</li>
          <li>Es gibt kein Kontaktformular. Daten werden bei Kontakt per E-Mail oder Telefon sowie in technisch notwendigen Server-Protokollen verarbeitet.</li>
        </ul>
        <h2>3. Hosting und Server-Protokolle</h2>
        <p>Diese Webseite wird bei der STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin, betrieben.
          Beim Aufruf übermittelt Ihr Browser automatisch Daten an den Server. Dazu gehören IP-Adresse,
          Datum und Uhrzeit, aufgerufene Seite oder Datei, Datenmenge und Statuscode, Referrer-URL
          sowie Browser und Betriebssystem.</p>
        <p>Die Verarbeitung dient der Auslieferung und dem sicheren, fehlerfreien Betrieb der Webseite
          sowie der Erkennung von Missbrauch. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
          Die Daten werden nur so lange gespeichert, wie sie für diese Zwecke erforderlich sind.
          Eine Zusammenführung mit anderen Datenquellen findet nicht statt.</p>
        <h2>4. Verschlüsselung</h2>
        <p>Bei einem Aufruf über „https://“ werden Daten zwischen Ihrem Browser und dem Server verschlüsselt übertragen.</p>
        <h2>5. Kontakt per E-Mail oder Telefon</h2>
        <p>Wenn Sie uns kontaktieren, verarbeiten wir Ihre Angaben wie Name, Kontaktdaten und Inhalt
          der Anfrage zur Bearbeitung Ihres Anliegens. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          bei vertraglichen oder vorvertraglichen Anfragen, im Übrigen Art. 6 Abs. 1 lit. f DSGVO.
          Unser berechtigtes Interesse liegt in der Beantwortung Ihrer Anfrage.</p>
        <p>Wir löschen diese Daten, sobald sie nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>
        <h2>6. Links zu anderen Webseiten</h2>
        <p>Beim Anklicken externer Links gelten die Datenschutzinformationen des jeweiligen Anbieters.</p>
        <h2>7. Ihre Rechte</h2>
        <ul>
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
        </ul>
        <p>Bei einer Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO können Sie aus Gründen,
          die sich aus Ihrer besonderen Situation ergeben, jederzeit widersprechen.
          Wenden Sie sich dazu an die oben genannten Kontaktdaten.</p>
        <h2>8. Beschwerderecht</h2>
        <p>Sie können sich bei einer Datenschutz-Aufsichtsbehörde beschweren, insbesondere beim
          Landesbeauftragten für den Datenschutz und die Informationsfreiheit Baden-Württemberg:
          <a href="https://www.baden-wuerttemberg.datenschutz.de">www.baden-wuerttemberg.datenschutz.de</a>.</p>
        <h2>9. Änderungen</h2>
        <p>Wir passen diese Erklärung bei Änderungen der Webseite oder rechtlicher Vorgaben an.</p>
      </div>
    </template>
  </menikheim-layout>
</template>

<script>
import MenikheimLayout from "@/layouts/MenikheimLayout.vue";

export default {
  name: "DatenschutzPage",
  components: { MenikheimLayout },
};
</script>
